import React, { Component } from 'react';

/**@type {any} */
const icons = {
  error: {
    icon: 'circle exclamation',
    color: 'red',
    code: '#BF2600'
  },
  warning: {
    icon: 'exclamation triangle',
    color: 'yellow',
    code: '#B4B400'
  },
  success: {
    icon: 'circle check',
    color: 'green',
    code: '#00A656'
  },
  info: {
    icon: 'circle info',
    color: 'gray',
    code: 'rgba(0, 0, 0, 0.6)'
  }
};

/**
 * @typedef {{
 *  type: string,
 *  text: string,
 *  style?: React.CSSProperties,
 *  visibleTime: number,
 *  visible?: boolean,
 *  close?: boolean,
 *  onClose?: () => null
 * }} Props
 * @extends {Component<Props>}
 */
export default class Alert extends React.Component {
  /**@param {Props} props*/
  constructor(props) {
    super(props);
    this.state = {
      visible: props.visible !== undefined ? props.visible : true
    };
  }

  /**@param {Props} prevProps*/
  componentDidUpdate = (prevProps) => {
    // handle when fathers component update
    if (prevProps.visible !== this.props.visible) {
      this.setState({ visible: this.props.visible });
    }
  }

  show = () => {
    this.setState({ visible: true });
  }

  close = () => {
    const { onClose } = this.props;

    this.setState({ visible: false }, () => { if (onClose) onClose(); });
  }

  render() {
    const {
      text, type, style, visibleTime, close
    } = this.props;
    const { visible } = this.state;
    const icon = icons[type] || {};

    if (visibleTime && visibleTime > 0 && visible) setTimeout(this.close, visibleTime);

    return (
      <div className={visible ? 'alert visible' : 'alert invisible'} data-testid={`${type}-alert`}>
        <div className={`alert background ${icon.color}`} style={style}>
          <i className={`icon ${icon.icon}`} style={{ color: icon.code }} />
          <span>{text}</span>
          {close && <i className="icon times" onClick={this.close} data-testid={`${type}-alert-close-icon`} />}
        </div>
      </div>
    );
  }
}
